<template>
  <section class="d-flex flex-column h-100" data-testid="readingform-register">
    <p class="mb-2" data-testid="readingform-register-label">
      Register: {{ registerLabel }}
    </p>

    <div class="d-flex mb-5">
      <SoTextField
        v-model="readingValue"
        type="number"
        class="register-input"
        :rules="[meterReadingValidation]"
        data-testid="readingform-register-input"
      >
        <template #append>
          <span
            class="register-input__unit text-h6 w-0"
            data-testid="readingform-register-inputunit"
            >{{ register.unit }}</span
          >
        </template>
      </SoTextField>
    </div>
    <p
      v-if="register.lastRealRead"
      class="mb-2 d-flex align-center"
      data-testid="readingform-register-lastread"
    >
      Last reading: {{ register.lastRealRead.cumulative }} on
      {{ formatDate(register.lastRealRead.date) }}
      <SoStatus class="ml-2" :status="register.lastRealRead.dateStatus" />
    </p>

    <p class="mb-3" data-testid="readingform-register-usage">
      Lower: {{ register.lowerBound }} | Upper: {{ register.upperBound }} |
      {{ register.unit === "kWh" ? "EAC" : "AQ" }}: {{ register.usage }} kWh
    </p>
  </section>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoStatus from "@/components/SoStatus.vue"
  import SoTextField from "@/components/formControls/SoTextField.vue"
  import { formatDate } from "@/helpers/dateHelper"
  import meterReadingValidation from "@/validators/meterReading"
  import { IRegister } from "@/models/meterRegister/meterRegister.types"

  export default defineComponent({
    components: { SoStatus, SoTextField },
    props: {
      modelValue: {
        type: String,
        default: "",
      },
      register: {
        type: Object as PropType<IRegister>,
        required: true,
      },
      showRegisterRate: {
        type: Boolean,
      },
    },
    emits: ["update:modelValue"],
    data() {
      return { formatDate, meterReadingValidation }
    },
    computed: {
      readingValue: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
      registerLabel() {
        const serialNumber = this.register.identifier
        const rateName = this.register.rateName || "Standard"

        if (this.showRegisterRate && serialNumber) {
          return `${rateName} (${serialNumber})`
        }

        return rateName
      },
    },
  })
</script>

<style scoped>
  .register-input {
    width: 200px;
  }

  .register-input__unit {
    display: flex;
    align-self: flex-end;
    position: relative;
    left: 10px;
  }
</style>
